'use client';

import { useEffect } from 'react';
import { ROUTES } from 'constant';
import { useRouter } from 'next/navigation';

import { Box } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';

import {
  buildLoginUrlWithReturnPath,
  rememberCurrentPageForPostAuthLogin
} from 'utils';

const Home = () => {
  const router = useRouter();
  const { userInfo } = useAppSelector((state) => state.persistAuth);

  useEffect(() => {
    if (Boolean(userInfo?.token) && Boolean(userInfo?.clid)) {
      router.push(ROUTES.dashboard);
    } else {
      const returnPath = `${window.location.pathname}${window.location.search}`;
      rememberCurrentPageForPostAuthLogin();
      router.push(buildLoginUrlWithReturnPath(ROUTES.login, returnPath));
    }
  }, [router, userInfo]);

  return <Box />;
};

export default Home;
